import { useState } from 'react';
import { Form, Select, DatePicker, Button } from 'antd';
import Wrapper from '../components/Wrapper';
import { REPORT_OPTIONS, REPORT_URL_MAP } from './constants';
import dayjs from 'dayjs';
import { ReportType } from '~/types/report';
import { PaymentMethod } from '@restaurant/types';
import { OrderStatus } from '@restaurant/types';
import { DownloadOutlined } from '@ant-design/icons';
import httpClient from '~/http';
import {
  ORDER_STATUS_OPTIONS,
  PAYMENT_METHOD_OPTIONS,
} from '@restaurant/constants';

const { RangePicker } = DatePicker;

const Report = () => {
  const [orderReportOptionsDisabled, setOrderReportOptionsDisabled] =
    useState<boolean>(false);
  const handleSelectReportType = (type: ReportType) => {
    if (type == ReportType.Order || type == ReportType.OrderDetail) {
      setOrderReportOptionsDisabled(false);
      return;
    }
    setOrderReportOptionsDisabled(true);
  };

  const handleDownload = async ({
    type,
    period,
    orderStatus,
    payment,
  }: {
    type: ReportType;
    period: dayjs.Dayjs[];
    orderStatus: OrderStatus;
    payment: PaymentMethod;
  }) => {
    const params: any = {
      startDate: period[0].format('YYYY-MM-DD'),
      endDate: period[1].format('YYYY-MM-DD'),
    };

    if (type == ReportType.Order || type == ReportType.OrderDetail) {
      if (orderStatus) {
        params.orderStatus = orderStatus;
      }

      if (payment) {
        params.payment = payment;
      }
    }

    const response: any = await httpClient.get(
      `/download/csv/${REPORT_URL_MAP[type]}`,
      {
        params,
        responseType: 'blob',
      }
    );

    const filename = (() => {
      return `${type}_${period[0].format('YYYYMMDD')}_${period[1].format(
        'YYYYMMDD'
      )}.csv`;
    })();

    const downloadUrl = URL.createObjectURL(response.data);
    const a = document.createElement('a');
    a.href = downloadUrl;
    a.download = filename;
    a.click();

    URL.revokeObjectURL(downloadUrl);
  };

  return (
    <Wrapper>
      <Form
        name="report"
        layout="vertical"
        onFinish={handleDownload}
        labelAlign="left"
        labelCol={{ span: 6 }}
        wrapperCol={{ span: 18 }}
        style={{ maxWidth: 500 }}
        initialValues={{
          type: ReportType.Order,
          period: [dayjs(), dayjs()],
        }}
      >
        <Form.Item label="Report" name="type">
          <Select options={REPORT_OPTIONS} onChange={handleSelectReportType} />
        </Form.Item>
        <Form.Item label="Date Range" name="period">
          <RangePicker />
        </Form.Item>
        <Form.Item label="Order Status" name="orderStatus">
          <Select
            options={ORDER_STATUS_OPTIONS}
            disabled={orderReportOptionsDisabled}
            allowClear
          />
        </Form.Item>
        <Form.Item label="Payment Method" name="payment">
          <Select
            options={PAYMENT_METHOD_OPTIONS}
            disabled={orderReportOptionsDisabled}
            allowClear
          />
        </Form.Item>
        <Form.Item>
          <Button type="primary" htmlType="submit" icon={<DownloadOutlined />}>
            Download
          </Button>
        </Form.Item>
      </Form>
    </Wrapper>
  );
};

export default Report;
